export const mapDurationAmountDE = (duration: string) => {
    const mapping: Record<string, number> = {
        few_months: 12,
        one_to_two_years: 24,
        three_plus_years: 60,
        ongoing: 12
    };
    return mapping[duration] ?? null;
};
